const LOCALE_DICT: Record<string, string> = {
  PLN: 'pl-PL',
  USD: 'en-US',
  EUR: 'pl-PL',
};

const formatterCurrency = (amount: number, currency: string): string =>
  new Intl.NumberFormat(LOCALE_DICT[currency], { style: 'currency', currency, minimumFractionDigits: 0 }).format(amount);

export default formatterCurrency;
